import React from 'react';

function ExpandIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.625 3.125H21.875V9.375"
        stroke="#6F6C80"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 21.875H3.125V15.625"
        stroke="#6F6C80"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.8747 3.125L14.583 10.4167"
        stroke="#6F6C80"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 21.8747L10.4167 14.583"
        stroke="#6F6C80"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

ExpandIcon.propTypes = {};

export default ExpandIcon;
